module.exports = __webpack_public_path__ + "static/media/seats_faded@1080.53377c9b.jpg";